import { render, staticRenderFns } from "./ListServices.vue?vue&type=template&id=741177a0&scoped=true&lang=pug&"
import script from "./ListServices.vue?vue&type=script&lang=js&"
export * from "./ListServices.vue?vue&type=script&lang=js&"
import style0 from "./ListServices.vue?vue&type=style&index=0&id=741177a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741177a0",
  null
  
)

export default component.exports